// Commented out lines are used to connect to dev environment with local frontend
export const environment = {
  production: false,
  apiUrl: 'https://notifyme.dev.backend.elidev.dev/api/v1/',
  // apiUrl: 'http://172.16.0.68:12000/api/v1/',
  authServer: 'https://qa-auth.elidev.dev',
  ngAppServer: 'https://172.16.0.68:12003',
  // ngAppServer: 'http://localhost:4200',
  clientId: 'kPENO93gtwkPnZsfnW2VVfMEepNoSQ',
  scope: 'openid email offline_access elinotify:api',
};
